const PREFIX = 'argus.linear.oauth.'

interface PendingLinearAuthorization {
  readonly workspaceId: string
  readonly expiresAt: string
}

// Provider state binds this browser callback to one workspace.
export function savePendingLinearAuthorization(
  state: string,
  pending: PendingLinearAuthorization,
): void {
  sessionStorage.setItem(`${PREFIX}${state}`, JSON.stringify(pending))
}

// Removing state before parsing makes each callback single-use.
export function takePendingLinearAuthorization(
  state: string,
): PendingLinearAuthorization | null {
  const key = `${PREFIX}${state}`
  const raw = sessionStorage.getItem(key)
  sessionStorage.removeItem(key)
  if (raw === null) return null

  try {
    const value: unknown = JSON.parse(raw)
    if (
      typeof value !== 'object' ||
      value === null ||
      !('workspaceId' in value) ||
      !('expiresAt' in value) ||
      typeof value.workspaceId !== 'string' ||
      value.workspaceId.length === 0 ||
      typeof value.expiresAt !== 'string' ||
      !Number.isFinite(Date.parse(value.expiresAt)) ||
      Date.parse(value.expiresAt) <= Date.now()
    ) {
      return null
    }
    return {
      workspaceId: value.workspaceId,
      expiresAt: value.expiresAt,
    }
  } catch {
    return null
  }
}
